import { A as Avatar, d as defineCustomElement$1 } from './avatar.js';

const TtAvatar = Avatar;
const defineCustomElement = defineCustomElement$1;

export { TtAvatar, defineCustomElement };
